var React = require('react');

function ClipPath (props) {
    return React.createElement("svg",props,React.createElement("defs",null,React.createElement("clipPath",{"id":"clipPath"},React.createElement("path",{"d":"M2810.364,2237.189c26.9-1.136,212.222.4,236.418,2.182s9.366,309.231,9.366,309.231-61.725-49.242-80.946-72.448-8.442-62.9-99.274-69.7-70.741-24.83-99.821-78.73S2783.465,2238.325,2810.364,2237.189Z","transform":"translate(-2765.393 -2236.799)"}))));
}

ClipPath.defaultProps = {"width":"0","height":"0"};

module.exports = ClipPath;

ClipPath.default = ClipPath;
